import { Flex, List } from 'antd';
import { Link } from 'react-router';
import styled from 'styled-components';

export const Container = styled(Flex)`
  margin: 50px auto 0;
  max-width: 1200px;
  padding: 0 24px;

  .tabs {
    .ant-tabs-tab {
    }
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: #334423;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
`;

export const CardTitle = styled.h3`
  flex: 1;
  margin: 0;
  color: ${(props) => props.theme.antd?.colorTextBase};
  font-size: 18px;
  font-weight: 500;
  &.disabled {
    color: ${(props) => props.theme.antd?.colorTextSecondary};
  }
`;

export const CardLink = styled(Link)`
  margin: 0;
  line-height: 22px;
  font-size: 14px;
  &.disabled {
    color: ${(props) => props.theme.antd?.colorTextSecondary};
  }
`;

export const SuggestionTitle = styled.h4`
  margin: 20px 0;
  color: ${(props) => props.theme.antd?.colorTextBase};
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
`;

export const TabPaneContainer = styled.div`
  height: 280px;
  background: #fff;
  padding: 16px;
  margin-top: -16px;
  overflow-y: auto;
`;
